import React from "react";
import { Flex, SimpleGrid, Spacer, Box, Text } from "@chakra-ui/react";
import InfoProfile from "./InfoProfile";
import ResetPassword from "./ResetPassword";
import DeleteUser from "./DeleteUser";
import ShowAvatarProfile from "./ShowAvatarProfile";
import "./../StylesPages/profile.css";

function ShowProfile(props) {
  return (
    <>
      <Flex
        px={[0, 0, 10, 10]}
        py={[0, 0, 5, 5]}
        spacing={200}
        direction={{ base: "column", md: "row" }}
      >
        <Box
          bg="#d4eeff"
          width={["100%", "100%", "33%", "33%"]}
          px={"40px"}
          paddingTop={"40px"}
          borderRadius="40px"
          fontWeight={"bold"}
          marginBottom={"20px"}
        >
          <Text
            fontFamily={"Sofia Pro"}
            fontSize="xl"
            fontWeight={"bold"}
            color="black"
            align={"left"}
          >
            Informations personnelles
          </Text>
          <InfoProfile />
        </Box>

        <Box
          bg="white"
          width={["100%", "100%", "33%", "33%"]}
          borderRadius="20px"
          marginBottom={"20px"}
          marginStart={[0, 0, 4, 4]}
          px={[0, 0, 4, 4]}
        >
          <SimpleGrid columns={1} h={"100%"} spacing={[5, 5, 10, 10]} w="100%">
            <Box bg="#d4eeff" w="100%" p={4} borderRadius="40px">
              <ResetPassword></ResetPassword>
            </Box>
            <Box bg="#d4eeff" w="100%" p={4} borderRadius="40px">
              <DeleteUser></DeleteUser>
            </Box>
          </SimpleGrid>
        </Box>

        <Box
          width={["100%", "100%", "33%", "33%"]}
          height={"300px"}
          p={4}
          marginStart={[0, 0, 4, 4]}
          borderRadius="20px"
        >
          <ShowAvatarProfile />
        </Box>
      </Flex>
    </>
  );
}

export default ShowProfile;
